export default "__VITE_ASSET__0f20fae8__"